import { render, staticRenderFns } from "./MapsYears.vue?vue&type=template&id=1f8b834e"
import script from "./MapsYears.vue?vue&type=script&lang=js"
export * from "./MapsYears.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports